import { socialServiceActionsOps } from "../api/operations";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";
export const conf = defineEntity({
  ...entityFactory("social-service-actions"),
  endpoint: "social-service-actions",
  operations: socialServiceActionsOps,
  roleView: [ROLE.SC_TASK_CATEGORY_VIEW, ROLE.SC_TASK_CATEGORY_ADMIN],
  roleAdmin: [ROLE.SC_TASK_CATEGORY_ADMIN],
  singularName: (t) => t("Action"),
  name: (t) => t("Actions"),
  syncCustomerFilter: true,
  dependencies: ["service-task"],
  sendCulture: true,
});
export default conf;
